import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';

const getNotificationCountFilters = () => {
    const createdAtGte = new Date();
    createdAtGte.setDate(createdAtGte.getDate() - 30);
    createdAtGte.setHours(0, 0, 0, 0);

    return {
        createdAt_gte: createdAtGte,
        isRead: false,
    };
};

export const useNotificationCount = () => {
    const dataProvider = useDataProvider();

    const { data } = useQuery({
        queryKey: ['notification', 'count'],
        queryFn: () => dataProvider.summary('notification/count', { filter: getNotificationCountFilters() }),
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });

    return data?.data?.total ?? 0;
};
